export enum UserType {ADMIN, CLIENT}
export default interface UserEntity {
    name: string;
    role: UserType;
    clientName: string;
    operationName: string;
    photo?: string;
    id: string;
}